import {CoreModel} from '../../model/CoreModel';
import {CoreMessageDispatcher} from '../../controller/CoreMessageDispatcher';
import {CoreEvents} from '../../events/CoreEvents';
import {analyticsEvent} from '../../../../../viscomjs/analytics/analyticsEvent';
import {GotoNewState} from './GotoNewState';
import {longMonth} from '../../../helpers/FormatMonth';
import {GetAnalyticsStateName} from '../../../helpers/GetAnalyticsStateName';

const WaitForMenuToClose = doThat => {
    return new Promise(resolve => {
        if (!doThat) {
            resolve(doThat);
            return;
        }
        const model = CoreModel.instance();
        const curState = model.state;

        if (model.menuOn) {
            const lr = () => {
                CoreMessageDispatcher.instance().removeListener(CoreEvents.MENU_STATE_CHANGED, lr);
                if (!model.menuOn && curState === model.state) {
                    setTimeout(() => {
                        resolve(curState === model.state ? doThat : false);
                    }, 1100);
                }
            };
            CoreMessageDispatcher.instance().addListener(CoreEvents.MENU_STATE_CHANGED, lr);

            return;
        }

        resolve(doThat);
    });
};

const AutoplayToNewState = doThat => {
    //
    return WaitForMenuToClose(doThat)
        .then(GotoNewState)
        .then(doThat => {
            return new Promise(resolve => {
                if (!doThat) {
                    resolve(doThat);
                    return;
                }
                const model = CoreModel.instance();
                //
                // Analytics
                analyticsEvent(
                    'Navigation',
                    'autoplay',
                    `autoplay to: ${model.currentEventOpened ? longMonth(model.currentEventIndex) : GetAnalyticsStateName(model.state)}`
                );
                resolve(doThat);
            });
        });
};

export {AutoplayToNewState};
